import type { RetailerNetworkLocationConnectionStatus } from '@occc/graphql';

// Local string-literal mirror of the generated `RetailerNetworkLocationConnectionStatus` enum —
// kept as a plain union (rather than importing the enum directly) because this type is used for
// URL query-param parsing/typing (e.g. `<StoreFilterBar>`'s <select> value), where a TS enum
// adds friction without benefit. The literal values must stay in sync with the generated enum.
export type ConnectionStatus = 'ONLINE' | 'OFFLINE';

export const CONNECTION_STATUS_OPTIONS: ConnectionStatus[] = ['ONLINE', 'OFFLINE'];

export const CONNECTION_STATUS_LABELS: Record<ConnectionStatus, string> = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
};

// Casts a URL-param-sourced `ConnectionStatus` to the generated GraphQL enum for use in a
// `RetailerNetworkLocationFilter.connectionStatusEquals` value — safe because the literal
// values are identical to the enum's string values.
export const toConnectionStatusEquals = (
  connectionStatusFilter: ConnectionStatus | '',
): RetailerNetworkLocationConnectionStatus | undefined =>
  (connectionStatusFilter || undefined) as RetailerNetworkLocationConnectionStatus | undefined;
